






















































import {
  defineComponent,
  ref,
  onMounted,
  useRoute,
} from '@nuxtjs/composition-api';

import {
  SfLink,
  SfHeading
} from '~/components';

import { useCollections } from '~/composables';

import collectionsGetters from '~/modules/collections/getters/collectionsGetters';

export default defineComponent({
  name: 'Collections',
  components: {
    SfHeading,
    SfLink,
  },
  setup() {
    const route = useRoute();
    const collectionType = ref(null);

    const {
      collections,
      loadCollections
    } = useCollections();

    const extractCollectionType = () => {
      if (route.value && route.value.fullPath) {
        const match = route.value.fullPath.match(/\/collections\/([^/]+)/);
        if (match) {
          collectionType.value = match[1];
        } else {
          collectionType.value = null; // если нет совпадений
        }
      }
    };

    onMounted(async () => {
      extractCollectionType();

      if (collectionType.value) {
        await loadCollections(collectionType.value);
      }
    });

    return {
      collections,
      ...collectionsGetters,
    };
  },
});
